import { Form, Input, Button, message } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { NumericFormat } from "react-number-format";
import { validations } from "src/utils/custom.validator";
import { useCallback, useState } from "react";
import apiCalls from "src/api/apiCalls";
const VerifyAuthenticator = ({ handleVerifyCode, handleVerifyAuthenticator, handleRecoveryCodes, handleError }) => {
    const [verifyAuthenticationObj, setVerifyAuthenticationObj] = useState(null);
    const [isVerifyAuthCode, setIsVerifyAuthCode] = useState(false);
    const [verificationDisabled, setVerificationDisabled] = useState(false);
    const [verifyButtonDisabled, setVerifyButtonDisabled] = useState(true);
    const handleVerifyAuthCode = useCallback(async (values) => {
        setIsVerifyAuthCode(true);
        try {
            let response = await apiCalls.verifyTwoFa({ code: values.code });
            if (response.ok) {
                setVerifyAuthenticationObj(response?.data);
                setVerificationDisabled(true);
                await setTwoFa();
                if (handleRecoveryCodes) handleRecoveryCodes(response?.data);
                handleError(null);
                message.success({
                    content: "Authenticator Verified Successfully.",
                    className: "custom-msg",
                    duration: 3,
                })
            } else {
                handleError(response?.data);
                window.scrollTo(0, 0);
            }
        } catch (error) {
            handleError(error);
            window.scrollTo(0, 0);
        } finally {
            setIsVerifyAuthCode(false);
        }
    }, [handleRecoveryCodes, handleError]);
    const setTwoFa = useCallback(async () => {
        try {
            let response = await apiCalls.setTwoFaEnable(true);
            if (response.ok) {
                handleError(null);
            }
            else {
                handleError(response?.data);
            }
        } catch (error) {
            handleError(error);
            window.scrollTo(0, 0);
        }
    }, [handleError]);
    const handleVerifyNext = useCallback(() => {
        if (handleVerifyCode) {
            handleVerifyCode();
        }
    }, [handleVerifyCode])
    const handleVerifyauth = useCallback(() => {
        if (handleVerifyAuthenticator) {
            handleVerifyAuthenticator();
            handleError(null);
        }
    }, [handleVerifyAuthenticator])
    const handleVerify = useCallback((e) => {
        const value = e.value
        if (value?.length == 6) {
            setVerifyButtonDisabled(false)
        }
        else {
            setVerifyButtonDisabled(true)
        }
    }, [])
    return (
        <div className="verify-authenticator-container p-3.5 mt-4">
            <div className="verify-card">
                <h3 className="verify-title text-lg font-semibold text-darkWhite text-center">Verify the Authenticator</h3>
                <p className="text-paraColor text-sm font-normal text-center">
                    Your two-factor authentication application will generate a code, enter this code in the box below and confirm.
                </p>
                <Form layout="vertical" onFinish={handleVerifyAuthCode}>
                    <div className="relative md:w-2/5 w-full m-auto mt-5">
                        <Form.Item
                            label="Code"
                            name="code"
                            rules={[validations.requiredValidator()]}
                            className="custom-input mb-0"
                        >
                            <NumericFormat
                                className=""
                                disabled={verificationDisabled}
                                placeholder="Enter Code"
                                maxLength={6}
                                thousandSeparator={false}
                                allowNegative={false}
                                customInput={Input}
                                allowLeadingZeros={true}
                                onValueChange={handleVerify}
                            />
                        </Form.Item>
                        <Button className="primary-btn !w-24 !bg-varifyBg hover:!bg-varifyBg absolute right-0 top-[26px] hover:!transform-none" type="primary" htmlType="submit" icon={verifyAuthenticationObj !== null && <CheckCircleOutlined />} loading={isVerifyAuthCode} disabled={verifyButtonDisabled}>
                            {verifyAuthenticationObj === null && "Verify"}
                            {verifyAuthenticationObj !== null && "Verified"}
                        </Button>
                    </div>
                    <div className="button-group">
                        <div className="button-container !mt-7 md:!flex !block md:!space-x-4  space-y-3 md:space-y-0">
                            <Button className='cancel-btn !py-5 md:!w-40 !w-full' key="back" onClick={handleVerifyauth}>Authenticator</Button>
                            <Button className="primary-btn !w-full md:!w-40" type="primary" htmlType="submit" disabled={verifyAuthenticationObj === null} onClick={handleVerifyNext}>
                                Next Step
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
}
export default VerifyAuthenticator